<template>

  <div class="ad-block">
    <div :class="containerClass">
      <div class="ad-wrap">
        <Adsense data-ad-client="ca-pub-4296186765472233"
                 data-ad-slot="8254553837">
        </Adsense>
      </div>
    </div>
  </div>

</template>

<script>

  import _ from 'underscore'

export default {
    props: ['containerClass'],
   
    data() {
      return {
        
      }
    },
    mounted() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .ad-block { background: #FFFFFF; text-align:center;margin:0px auto;}
  .be-content .ad-block, .left-sidebar-content .ad-block { background: none; }

  @media (max-width: 780px) {
    .ad-block a.side-by-side { float: none; width: 100%; }
    .ad-block a:first-child {padding-bottom:20px;}
  }

  .no-pad .ad-wrap {margin:0px;} 
  .no-pad .ad-wrap a { padding: 0px; }

  .test { background: #DD0000; width: 100%; height: 100px; }
</style>



// WEBPACK FOOTER //
// VerticalAd.vue?715e5513